import axios from 'axios'

const baseURL = process.env.REACT_APP_BASE_URL || ''

const request = axios.create({
  baseURL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

request.interceptors.response.use(
  (res) => res,
  (error) => {
    const msg =
      error.code === 'ECONNABORTED'
        ? '请求超时，请稍后重试'
        : error.response?.status === 404
          ? '接口不存在'
          : '网络异常，请检查网络后重试'
    return Promise.reject(new Error(msg))
  }
)

export default request